import { basicEnum } from "./base";

export const InvoiceScheduleEnum = basicEnum([
    {
        label: "Sesuai Aktivasi",
        value: "F", // Fixed Date
    },
    {
        label: "Sesuai Jadwal Sistem (Pro Rata)",
        value: "C", // Billing Cycle
    },
    {
        label: "Prabayar Bulanan (Tidak Otomatis)",
        value: "R", // Renewal
    },
    {
        label: "Manual / Tidak Ada",
        value: "N", // None
    },
]);

export namespace InvoiceScheduleEnum {
    export type Labels = (typeof InvoiceScheduleEnum)["labels"][number];
    export type Values = (typeof InvoiceScheduleEnum)["values"][number];
}
